import { cacheKey } from '@/constants/cache-key';
import {
	type IApiResponse,
	type ICreateParty,
	type IGetPartyByIDState,
	type IPartyState,
	type IUpdatePrty,
} from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

export const partyApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createParty: builder.mutation<IApiResponse, ICreateParty>({
			query: (body) => ({
				method: 'POST',
				url: '/Party',
				body,
			}),
		}),
		getParty: builder.mutation<IApiResponse<IPartyState[]>, IGetQuery & { Name?: string; PageNumber?: number | undefined }>({
			query: ({ paged, query, ...params }) => ({
				method: 'GET',
				url: `/Party${getCoreQuery(paged, ...(query || []))}`,
				params,
			}),
		}),
		getPartyById: builder.mutation<IApiResponse<IGetPartyByIDState>, { id: string }>({
			query: ({ id }) => ({
				method: 'GET',
				url: `/Party/${id}`,
			}),
		}),
		getPartyByName: builder.mutation<IApiResponse, { name: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Party/name',
				body,
			}),
		}),
		updatedParty: builder.mutation<IApiResponse, IUpdatePrty>({
			query: (body) => ({
				method: 'POST',
				url: '/Party/update',
				body,
			}),
		}),
		deleteParty: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/Party/delete/${id}`,
			}),
		}),
	}),
});

export const {
	useCreatePartyMutation,
	useGetPartyByIdMutation,
	useGetPartyByNameMutation,
	useGetPartyMutation,
	useUpdatedPartyMutation,
	useDeletePartyMutation,
} = partyApiSlice;

export const selectGetParty = partyApiSlice.endpoints.getParty.select({
	fixedCacheKey: cacheKey.GET_PARTY,
	requestId: '',
});
